import { type FC } from 'react'
import classnames from 'classnames'
import { observer } from 'mobx-react-lite'
import { Badge, IconButton, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type SmartView } from 'entities/SmartViews/model/SmartView'
import { useConversationMenuContext } from 'pages/conversations/ui/ConversationMenu/context'
import { DropdownSmartViewInbox } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/DropdownSmartViewInbox/DropdownSmartViewInbox'
import styles from './styles.module.scss'

type IMenuCardSmartViewInboxProps = {
  item: SmartView
  onClickItemTree?: () => void
}

export const MenuCardSmartViewInbox: FC<IMenuCardSmartViewInboxProps> = observer(
  ({ item: inbox, onClickItemTree }) => {
    const store = useConversationMenuContext()
    const { inboxesStore } = useEntitiesContext()
    const { loadingUpdateTeam, disabledActive, smartViewsMenuStore, isActiveConversationSearch } =
      store
    const { currentInboxId } = inboxesStore.localInboxes
    const active = currentInboxId === inbox.id
    const handleClickUpdateTeam = async () => {
      if (loadingUpdateTeam) return
      if (active && !isActiveConversationSearch) {
        onClickItemTree?.()

        return
      }

      smartViewsMenuStore.setActiveItem(inbox.id)
      onClickItemTree?.()
    }

    return (
      <div
        className={classnames(styles.wrap, {
          [styles.active]: active && !disabledActive,
          [styles.disabled]: loadingUpdateTeam,
        })}
        onClick={handleClickUpdateTeam}
      >
        <div
          className={classnames(styles.boxName, {
            [styles.muted]: inbox.isMuted,
            [styles.unread]: inbox.unreadCount,
          })}
        >
          <div className={styles.icon}>
            <IconButton
              iconProps={{
                color:
                  active && !disabledActive
                    ? 'var(--content-brand-primary)'
                    : !active && inbox.isMuted
                    ? 'var(--content-neutral-primary)'
                    : undefined,
              }}
              icon='filter2'
              size={'small'}
              color={'transparent'}
              fontSize={16}
              ariaLabel='MenuCardInbox'
            />
          </div>

          <Typography
            variant={inbox.unreadCount && !inbox.isMuted ? 'body-md-semibold' : 'body-md-regular'}
            ellipsis
            color={
              inbox.isMuted ? 'var(--content-primary-tertiary)' : 'var(--content-primary-primary)'
            }
            ariaLabel={'name'}
          >
            {inbox.name}
          </Typography>
        </div>

        {Boolean(inbox.unreadCount) && (
          <div className={styles.right}>
            <div
              className={classnames(styles.boxInfo, {
                [styles.isMuted]: inbox.isMuted,
                [styles.unread]: inbox.unreadCount,
              })}
            >
              <div className={styles.infoItem}>
                <Badge
                  content={inbox.unreadCount}
                  maxLimitContent={1_000}
                  ariaLabel={'MenuCardInbox_unreadMessagesCount'}
                />
              </div>
            </div>
          </div>
        )}
        <div className={styles.boxDropdownMenu}>
          <div className={styles.dropdownMenu}>
            <DropdownSmartViewInbox inbox={inbox} />
          </div>
        </div>
      </div>
    )
  }
)
